import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { CarrentCardFilters } from '@app/models/carrent/CarrentCardFilters';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersResponse } from '@app/models/offers/CarrentFiltersResponse';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'app-carrentfilter',
    templateUrl: './carrentfilter.component.html',
    styleUrls: ['./carrentfilter.component.scss'],
    standalone: false
})
export class CarrentfilterComponent implements OnInit, OnDestroy {
    @Input() mode: string;
    @Input() realparams: CarrentCardFilters;
    @Input() reference: string;
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showMore: boolean = false;
    smallVersion: boolean = true;
    filter: CarrentFilters;

    start = signal<string>('');
    end = signal<string>('');
    btntext = signal<string>('SUCHEN');

    reisende = [
        {
            name: '1 Person',
            code: '1'
        },
        {
            name: '2 Personen',
            code: '2'
        },
        {
            name: '3 Personen',
            code: '3'
        },
        {
            name: '4 Personen',
            code: '4'
        },
        {
            name: '5 Personen',
            code: '5'
        },
        {
            name: '6 Personen',
            code: '6'
        },
        {
            name: '7 Personen',
            code: '7'
        },
        {
            name: '8 Personen',
            code: '8'
        }
    ];

    constructor(
        protected mediaService: MediaService,
        protected cdr: ChangeDetectorRef,
        protected carrentFilterService: CarrentFiltersService,
        protected trafficsService: TrafficsService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        this.getFilters();
        this.initFilterSub();
    }


    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initFilterSub(): void {
        this.carrentFilterService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: CarrentFilters) => {
            if (filter) {
                this.filter = JSON.parse(JSON.stringify(filter));
                this.cdr.detectChanges();
                this.initDate(filter);
            }
        });
    }

    getFilters() {
        this.trafficsService.request({}, 'offers/carrent/filters').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res: CarrentFiltersResponse) => {
            this.carrentFilterService.setExtras(res);
            this.initFilters();
        });
    }

    async initDate(filter) {
       if (filter?.start?.length > 0) {
            this.start.set(moment(filter.start).format('YYYY-MM-DD'));
            this.end.set(moment(filter.end).format('YYYY-MM-DD'));
        } else if (!isNaN(Number(filter?.start))) {
            this.start.set(moment().add(Number(filter.start), 'days').format('YYYY-MM-DD'));
            this.end.set(moment().add(Number(filter.end), 'days').format('YYYY-MM-DD'));
        } else {
            this.start.set(moment().add(4, 'days').format('YYYY-MM-DD'));
            this.end.set(moment().add(180, 'days').format('YYYY-MM-DD'));
        }
    }

    gotoZiel(): void {
        this.smallVersion = true;
        this.carrentFilterService.setReference(this.reference);
        this.carrentFilterService.gotoUrl();
    }

    showMBMenu(): void {
        this.smallVersion = false;
    }

    openclosemore(): void {
        this.showMore = !this.showMore;
        if (!this.showMore) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    initFilters(): void {
        if (this.realparams) {
            this.realparams.productType = 'carrent';
            this.carrentFilterService.onlySetRealParams(this.realparams);
        } else if (this.mode === 'home') {
            this.carrentFilterService.resetAllExtrasHome();
        } else {
            this.carrentFilterService.setOnlyNext();
        }
    }

    selectValue(ev): void {
        this.carrentFilterService.carrentdatevonf({ start: ev.start, end: ev.end }, this.mode === 'home');
    }

    selectAdultes(ev) {
        this.carrentFilterService.carrentreisendef(ev?.code, this.mode);
    }
}
